module.exports = [{"type":"Route","path":"/","component":"DashboardComponent","data":{"page":"Faver"}},{"type":"Route","path":"/success","component":"SuccessComponent","data":{"page":"Success"}},{"type":"Route","path":"/item/:id","component":"DetailItemComponent","data":{"page":"Item"}},{"type":"Route","path":"/list/:id","component":"ItemShareComponent","data":{"page":"Item Share"}}]


//////////////////
// WEBPACK FOOTER
// ./src/client/Routes.json
// module id = 400
// module chunks = 0